export const getUITime = (activeSinceTime: string, activeUntilTime?: string) =>
    `${activeSinceTime}${activeUntilTime ? '-' + activeUntilTime : ''}`;
